export default function(_el) {

  const link = _el;
  const content = document.getElementById(_el.dataset.jsModal);
  const dismiss = content.querySelector(`[data-js-modal-dismiss]`);
  const confirm = content.querySelector(`[data-js-modal-confirm]`);

  link.addEventListener('click', () => {
    const modalOpenEvent = new CustomEvent("modalOpen", { detail: {content: content} });
    _el.dispatchEvent(modalOpenEvent);
    
    content.classList.add('open');
  });

  if (dismiss) {
    dismiss.addEventListener('click', e => {
      content.classList.remove('open');
    });
  }

  if (confirm) {
    confirm.addEventListener('click', e => {
      alert('fire modal callback, and close');
      content.classList.remove('open');
    });
  }

}